export const getTemplateFilter = state => state.templates.filter
